import Collapse from '@material-ui/core/Collapse';
import MenuList from '@material-ui/core/MenuList';
import MarketingIcon from '@material-ui/icons/AccountBalanceWallet';
import LinkIcon from '@material-ui/icons/Link';
import LockIcon from '@material-ui/icons/Lock';
import * as React from 'react';
import { HasPermissions } from '../../components/HasPermissions';
import { useMiaSelector } from '../../components/hooks';
import { LeftNavHeader } from '../../components/LeftNavHeader';
import { isItOverriddenByType } from '../../ducks/auth';
import { NavTypes, NavUrls } from '../layoutConstants';
import { MenuLink } from '../MenuLink';
import { TargetedCatalogNav } from '../sharedNavs/TargetedCatalogNav';

interface IMarketingMenuProps {
  collapsed: boolean;
  menuClassName: string;
  navType: NavTypes;
  onExpandClick: (navType: NavTypes) => any;
  onNavClick: () => any;
  currentLocation: string;
}

let MarketingMenu: React.FunctionComponent<IMarketingMenuProps> = ({
  collapsed,
  menuClassName,
  onExpandClick,
  onNavClick,
  navType,
  currentLocation
}) => {
  const isNavItOverridden = useMiaSelector(state => isItOverriddenByType(state, 'marketing'));

  React.useEffect(() => {
    if (currentLocation.includes('marketing') || currentLocation.includes('targetedCatalog')) {
      onExpandClick('marketing');
    }
  }, []);

  return (
    <HasPermissions type="marketing">
      <LeftNavHeader
        collapsed={collapsed}
        navType={navType}
        onExpandClick={onExpandClick}
        icon={MarketingIcon}
        title="Marketing"
        hasWarningColor={isNavItOverridden}
      />
      <Collapse component="li" in={collapsed} timeout="auto" unmountOnExit>
        <MenuList disablePadding>
          <TargetedCatalogNav
            menuClassName={menuClassName}
            onNavClick={onNavClick}
            isActive={currentLocation === NavUrls.targetedCatalog}
          />
          <HasPermissions type="marketing" admin>
            <MenuLink
              icon={<LockIcon />}
              to={NavUrls.marketingAdmin}
              label="Admin"
              menuClassName={menuClassName}
              onNavClick={onNavClick}
            />
          </HasPermissions>
          <MenuLink
            icon={<LinkIcon />}
            to={NavUrls.marketingLinks}
            label="Links"
            menuClassName={menuClassName}
            onNavClick={onNavClick}
          />
        </MenuList>
      </Collapse>
    </HasPermissions>
  );
};

MarketingMenu = React.memo<IMarketingMenuProps>(MarketingMenu);
export { MarketingMenu };
